import React, { useState } from 'react';
import { Link } from 'react-router-dom';
function CarDriveInIcon({
  active
}: {
  active: boolean;
}) {
  const color = active ? '#FECB00' : 'rgba(255,255,255,0.40)';
  return <svg width="56" height="44" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-343">
      <polygon points="32,4 38,14 26,14" stroke={active ? '#FECB00' : 'rgba(255,255,255,0.30)'} strokeWidth="1.5" fill={active ? 'rgba(254,203,0,0.15)' : 'rgba(255,255,255,0.05)'} strokeLinejoin="round" data-id="element-344" />
      <text x="32" y="13" textAnchor="middle" fontSize="5" fill={active ? '#FECB00' : 'rgba(255,255,255,0.30)'} fontWeight="bold" data-id="element-345">
        !
      </text>
      <rect x="8" y="26" width="48" height="14" rx="3" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-346" />
      <path d="M16 26 L22 18 L42 18 L48 26" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-347" />
      <circle cx="20" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-348" />
      <circle cx="44" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-349" />
      <circle cx="20" cy="40" r="2" fill={color} data-id="element-350" />
      <circle cx="44" cy="40" r="2" fill={color} data-id="element-351" />
    </svg>;
}
function InspectionIcon({
  active
}: {
  active: boolean;
}) {
  const color = active ? '#FECB00' : 'rgba(255,255,255,0.40)';
  return <svg width="56" height="44" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-352">
      <circle cx="50" cy="14" r="4" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.10)' : 'transparent'} data-id="element-353" />
      <path d="M50 18 L50 30 M46 22 L54 22 M50 30 L46 38 M50 30 L54 38" stroke={color} strokeWidth="1.8" strokeLinecap="round" data-id="element-354" />
      <rect x="4" y="26" width="40" height="14" rx="3" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-355" />
      <path d="M10 26 L16 18 L34 18 L40 26" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-356" />
      <circle cx="14" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-357" />
      <circle cx="34" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-358" />
      <circle cx="14" cy="40" r="2" fill={color} data-id="element-359" />
      <circle cx="34" cy="40" r="2" fill={color} data-id="element-360" />
    </svg>;
}
function TireServiceIcon({
  active
}: {
  active: boolean;
}) {
  const color = active ? '#FECB00' : 'rgba(255,255,255,0.40)';
  return <svg width="56" height="44" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-361">
      <rect x="36" y="6" width="16" height="22" rx="2" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.10)' : 'rgba(255,255,255,0.04)'} data-id="element-362" />
      <rect x="40" y="3" width="8" height="5" rx="1" stroke={color} strokeWidth="1.5" fill={active ? 'rgba(254,203,0,0.12)' : 'rgba(255,255,255,0.04)'} data-id="element-363" />
      <path d="M44 14 Q44 20 44 22" stroke={color} strokeWidth="2" strokeLinecap="round" data-id="element-364" />
      <circle cx="44" cy="24" r="2" fill={color} data-id="element-365" />
      <circle cx="20" cy="28" r="14" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.04)' : 'transparent'} data-id="element-366" />
      <circle cx="20" cy="28" r="8" stroke={color} strokeWidth="1.5" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-367" />
      <circle cx="20" cy="28" r="3" fill={color} data-id="element-368" />
    </svg>;
}
function CarDoneIcon({
  active
}: {
  active: boolean;
}) {
  const color = active ? '#FECB00' : 'rgba(255,255,255,0.40)';
  const checkColor = active ? '#22c55e' : 'rgba(255,255,255,0.30)';
  return <svg width="56" height="44" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-369">
      <circle cx="48" cy="12" r="7" stroke={checkColor} strokeWidth="1.5" fill={active ? 'rgba(34,197,94,0.12)' : 'rgba(255,255,255,0.04)'} data-id="element-370" />
      <path d="M44 12 L47 15 L52 9" stroke={checkColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-371" />
      <rect x="4" y="26" width="48" height="14" rx="3" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-372" />
      <path d="M10 26 L16 18 L38 18 L44 26" stroke={color} strokeWidth="1.8" fill={active ? 'rgba(254,203,0,0.06)' : 'transparent'} data-id="element-373" />
      <circle cx="16" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-374" />
      <circle cx="40" cy="40" r="5" stroke={color} strokeWidth="1.8" fill={active ? '#1a1a1a' : 'transparent'} data-id="element-375" />
      <circle cx="16" cy="40" r="2" fill={color} data-id="element-376" />
      <circle cx="40" cy="40" r="2" fill={color} data-id="element-377" />
    </svg>;
}
const STEPS = [{
  id: 1,
  label: 'Drive In',
  time: '0 min',
  detail: '🚗 Pull up to any of our 3 locations — no appointment needed. Open 24 hours.',
  Icon: CarDriveInIcon
}, {
  id: 2,
  label: 'Free Inspection',
  time: '~5 min',
  detail: '🔍 Our technician inspects tread depth, pressure, and overall tire condition at no charge.',
  Icon: InspectionIcon
}, {
  id: 3,
  label: 'Tire Service',
  time: '~30 min',
  detail: '🛞 We perform your tire service — installation, rotation, repair, or balancing — with precision.',
  Icon: TireServiceIcon
}, {
  id: 4,
  label: 'Back on the Road',
  time: '~45 min',
  detail: '✅ Your vehicle is ready! Most services completed in under 45 minutes. Drive safe!',
  Icon: CarDoneIcon
}];
export function ServiceProcessSection() {
  const [activeStep, setActiveStep] = useState<number | null>(null);
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8" style={{
    background: '#0a0a0a'
  }} data-id="element-378">
      <div className="max-w-7xl mx-auto" data-id="element-379">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20" data-id="element-380">
          {/* LEFT: Heading + CTA */}
          <div className="flex-shrink-0 lg:w-52 lg:pt-4" data-id="element-381">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-382">
              How It Works
            </p>
            <h2 className="font-black text-white leading-none mb-2" style={{
            fontSize: '2.6rem'
          }} data-id="element-383">
              Our
              <br data-id="element-384" />
              Process
            </h2>
            <div className="w-8 h-0.5 mb-4" style={{
            background: '#FECB00'
          }} data-id="element-385" />
            <p className="text-sm mb-8" style={{
            color: '#616365'
          }} data-id="element-386">
              Tire Service
            </p>
            <Link to="/services" className="inline-block text-white text-xs font-black uppercase tracking-widest px-6 py-3 transition-colors duration-200" style={{
            background: '#CC0000',
            letterSpacing: '0.12em'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-387">
              Learn More
            </Link>
          </div>

          {/* RIGHT: Steps */}
          <div className="flex-1 w-full" data-id="element-388">
            {/* Step row */}
            <div className="flex items-start justify-between" data-id="element-389">
              {STEPS.map((step, idx) => <>
                  <button key={step.id} className="flex flex-col items-center gap-3 flex-1 focus:outline-none" onMouseEnter={() => setActiveStep(step.id)} onMouseLeave={() => setActiveStep(null)} onClick={() => setActiveStep(activeStep === step.id ? null : step.id)} aria-label={`Step ${step.id}: ${step.label}`} data-id="element-390">
                    {/* Icon circle */}
                    <div className="w-20 h-20 rounded-full flex items-center justify-center transition-all duration-300" style={{
                  background: activeStep === step.id ? 'rgba(254,203,0,0.08)' : 'rgba(255,255,255,0.04)',
                  border: activeStep === step.id ? '1.5px solid rgba(254,203,0,0.35)' : '1.5px solid rgba(255,255,255,0.10)',
                  transform: activeStep === step.id ? 'scale(1.10)' : 'scale(1)'
                }} data-id="element-391">
                      <step.Icon active={activeStep === step.id} data-id="element-392" />
                    </div>

                    {/* Step number badge */}
                    <div className="text-center" data-id="element-393">
                      <p className="font-black text-sm transition-colors duration-200" style={{
                    color: activeStep === step.id ? '#FECB00' : 'rgba(255,255,255,0.90)'
                  }} data-id="element-394">
                        {step.label}
                      </p>
                      <div className="flex items-center justify-center gap-1 mt-1" data-id="element-395">
                        <svg width="11" height="11" viewBox="0 0 12 12" fill="none" data-id="element-396">
                          <circle cx="6" cy="6" r="5" stroke={activeStep === step.id ? '#FECB00' : 'rgba(255,255,255,0.30)'} strokeWidth="1.2" data-id="element-397" />
                          <path d="M6 3.5V6L7.5 7.5" stroke={activeStep === step.id ? '#FECB00' : 'rgba(255,255,255,0.30)'} strokeWidth="1.2" strokeLinecap="round" data-id="element-398" />
                        </svg>
                        <span className="text-xs font-semibold" style={{
                      color: activeStep === step.id ? '#FECB00' : 'rgba(255,255,255,0.35)'
                    }} data-id="element-399">
                          {step.time}
                        </span>
                      </div>
                    </div>
                  </button>

                  {/* Dotted connector (not after last) */}
                  {idx < STEPS.length - 1 && <div key={`connector-${idx}`} className="flex-1 flex items-center justify-center mt-10 px-1" data-id="element-400">
                      <div className="w-full h-px" style={{
                  backgroundImage: 'repeating-linear-gradient(to right, rgba(255,255,255,0.20) 0px, rgba(255,255,255,0.20) 4px, transparent 4px, transparent 10px)'
                }} data-id="element-401" />
                    </div>}
                </>)}
            </div>

            {/* Tooltip — always rendered, no layout shift */}
            <div className="mt-8 px-6 py-4 text-sm font-medium transition-opacity duration-200" style={{
            background: 'rgba(254,203,0,0.06)',
            border: '1px solid rgba(254,203,0,0.15)',
            color: '#FECB00',
            opacity: activeStep ? 1 : 0,
            visibility: activeStep ? 'visible' : 'hidden',
            minHeight: '48px'
          }} data-id="element-402">
              {STEPS.find(s => s.id === activeStep)?.detail ?? '\u00A0'}
            </div>
          </div>
        </div>
      </div>
    </section>;
}